import { render } from "./HeaderHistory.vue?vue&type=template&id=505967ae&scoped=true"
import script from "./HeaderHistory.vue?vue&type=script&lang=js"
export * from "./HeaderHistory.vue?vue&type=script&lang=js"

import "./HeaderHistory.vue?vue&type=style&index=0&id=505967ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505967ae"]])

export default __exports__